export { UpgradeModal } from "scenes/Hubly/components/Workspace/components/UpgradeModal";
export { default as InsightsUpgradeModal } from "./InsightsUpgradeModal";
